import { useRef } from 'react';
import MetaTags from '@/components/MetaTags';
import LandingHero from '@/components/landing/LandingHero';
import CtaSection from '@/components/CtaSection';
import content from '@/constants/landing-content';
import LandingWhoWeServe from '@/components/landing/LandingWhoWeServe';
import LandingPricing from '@/components/landing/LandingPricing';
import { PAGE_META_DATA } from '@/constants/constants';
import useScrollSpy from '@/hooks/useScrollSpy';
import LandingClients from '@/components/landing/LandingClients';
import ContactButton from '@/components/ContactButton';

function Landing() {
  const clientsRef = useRef<HTMLDivElement>(null);
  const pricingRef = useRef<HTMLDivElement>(null);
  const whoWeServeRef = useRef<HTMLDivElement>(null);

  useScrollSpy(
    [
      { id: 'pricing', ref: pricingRef },
      { id: 'clients', ref: clientsRef },
      { id: 'who-we-serve', ref: whoWeServeRef },
    ],
    'pricing'
  );

  return (
    <div>
      <MetaTags title={PAGE_META_DATA.landing.title} description={PAGE_META_DATA.landing.description} />
      <LandingHero content={content.heroSection} className='!pb-0 mb-[-52px]' />
      <LandingPricing content={content.pricingSection} ref={pricingRef} />
      <LandingClients content={content.clientsSection} ref={clientsRef} background='white' />
      <LandingWhoWeServe content={content.whoWeServeSection} ref={whoWeServeRef} background='grey' />
      <CtaSection title={content.ctaBanner.title} label={content.ctaBanner.label} cta={<ContactButton />} />
    </div>
  );
}

export default Landing;
